'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

// NOTE: maplibre's Marker constructor expects an HTMLElement, and SVGElement/SVGSVGElement
// do not inherit from HTMLElement. Hence, wrapping the svg in a span.

// TODO: refactor this instead of disabling
// eslint-disable-next-line react/display-name
const MapMarker = /*#__PURE__*/React.forwardRef((_, ref) => /*#__PURE__*/React__default["default"].createElement("span", {
  ref: ref
}, /*#__PURE__*/React__default["default"].createElement("svg", {
  width: "33",
  height: "44",
  viewBox: "0 0 33 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React__default["default"].createElement("rect", {
  x: "8",
  y: "9",
  width: "17",
  height: "17",
  rx: "8.5",
  fill: "white"
}), /*#__PURE__*/React__default["default"].createElement("path", {
  d: "M16.5 0C7.38733 0 0 7.42577 0 16.5859C0 19.6493 0.596503 22.8133 2.30828 25.0937L16.5 44L30.6917 25.0937C32.2465 23.0224 33 19.3607 33 16.5859C33 7.42577 25.6127 0 16.5 0ZM16.5 9.60619C20.3343 9.60619 23.4436 12.7317 23.4436 16.5859C23.4436 20.4402 20.3343 23.5657 16.5 23.5657C12.6657 23.5657 9.55646 20.4402 9.55646 16.5859C9.55646 12.7317 12.6657 9.60619 16.5 9.60619Z",
  fill: "#FF3600"
}))));

exports["default"] = MapMarker;
